// Users GraphQL queries

import { gql } from "@apollo/client"

export const GET_USERS = gql`
  query GetUsers {
    getUsers {
      id
      displayName
      email
      userPrincipalName
    }
  }
`
